import { DraggableItem } from "../../pages/service/pages/catalog/pages/form/components/catalogOption/components/draggableItem/types";
import { CatalogByIdResponse, Categories, DropDownLinkResponse, Subcategories } from "./response"

const formatCatalogToItems = (data: CatalogByIdResponse): DraggableItem[] => {
    if (!data?.categories) return [];

    // Mapea los dropdowns recursivamente desde nivel 3 hacia abajo
    const mapDropDownLinks = (
        dropDowns: DropDownLinkResponse[],
        level: number,
    ): DraggableItem[] => {
        return dropDowns.map((drop) => {
            const firstChild = drop.nextValues?.[0];
            const subcatalog =
                firstChild?.parent?.id !== undefined ? firstChild.parent.id : undefined;

            return {
                id: String(drop.currentNode),
                itemSubCatalogId: drop.parent ? drop.currentDropDownId : undefined,
                label: drop.name,
                expand: false,
                level,
                isEditable: !drop.parent, // editable si no tiene padre
                children: mapDropDownLinks(drop.nextValues || [], level + 1),
                priority: undefined,
                provider: undefined,
                textInput: drop.requiredText ?? undefined,
                subcatalog: subcatalog,
            }
        });
    };

    //Mapea las subcategorías (nivel 2) 
    const mapSubcategories = (subs: Subcategories[]): DraggableItem[] => {

        return subs
            .sort((a, b) => (a.position ?? 0) - (b.position ?? 0))
            .map((sub) => {
                const firstChild = sub.dropDownLinks?.[0];
                const subcatalog =
                    firstChild?.parent?.id !== undefined ? firstChild.parent.id : undefined;
                return {
                    id: String(sub.id),
                    label: sub.name,
                    position: sub.position,
                    expand: false,
                    level: 2,
                    isEditable: true,
                    textInput: sub.requestText ?? false,
                    provider: sub.user?.id ?? undefined,
                    priority: sub.priority.id,
                    subcatalog: subcatalog,
                    children: (sub.dropDownLinks || []).flatMap((ddl) =>
                        mapDropDownLinks([ddl], 3)
                    ),
                };
            })
    };

    //Mapea las categorías (nivel 1) 
    const mapCategories = (categories: Categories[]): DraggableItem[] => {
        return categories.sort((a, b) => (a.position ?? 0) - (b.position ?? 0)).map((cat) => ({
            id: String(cat.id),
            label: cat.name,
            position: cat.position,
            expand: false,
            level: 1,
            isEditable: true,
            children: mapSubcategories(cat.subcategories || []),
        }));
    };

    return mapCategories(data.categories);
};

const formatCatalogById = ({ response }: { response: CatalogByIdResponse }) => {

    const items = response.errors
        ? [] : formatCatalogToItems(response)

    const catalogName = response.errors ? '' : response.name;

    return {
        catalogName,
        items
    }
}



export { formatCatalogById }